/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { StoreHistoryManagementEditOrderRequest } from '../models/StoreHistoryManagementEditOrderRequest';
import type { StoreHistoryManagementEditOrderResponseApiRespoonse } from '../models/StoreHistoryManagementEditOrderResponseApiRespoonse';
import type { StoreHistoryManagementExportOrderRequest } from '../models/StoreHistoryManagementExportOrderRequest';
import type { StoreHistoryManagementExportOrderResponseApiRespoonse } from '../models/StoreHistoryManagementExportOrderResponseApiRespoonse';
import type { StoreHistoryManagementListOrderRequest } from '../models/StoreHistoryManagementListOrderRequest';
import type { StoreHistoryManagementListOrderResponseApiRespoonse } from '../models/StoreHistoryManagementListOrderResponseApiRespoonse';
import type { StoreHistoryManagementShowItemRequest } from '../models/StoreHistoryManagementShowItemRequest';
import type { StoreHistoryManagementShowItemResponseApiRespoonse } from '../models/StoreHistoryManagementShowItemResponseApiRespoonse';
import type { StoreHistoryManagementShowOrderRequest } from '../models/StoreHistoryManagementShowOrderRequest';
import type { StoreHistoryManagementShowOrderResponseApiRespoonse } from '../models/StoreHistoryManagementShowOrderResponseApiRespoonse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class StoreHistoryManagementStoreHistoryService {

    /**
     * 注文一覧
     * @param requestBody
     * @returns StoreHistoryManagementListOrderResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminStoreHistory(
        requestBody: StoreHistoryManagementListOrderRequest,
    ): CancelablePromise<StoreHistoryManagementListOrderResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/store-history',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * 注文の更新
     * @param requestBody
     * @returns StoreHistoryManagementEditOrderResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminStoreHistoryEdit(
        requestBody: StoreHistoryManagementEditOrderRequest,
    ): CancelablePromise<StoreHistoryManagementEditOrderResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/store-history/edit',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * 注文表示
     * @param requestBody
     * @returns StoreHistoryManagementShowOrderResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminStoreHistoryShow(
        requestBody: StoreHistoryManagementShowOrderRequest,
    ): CancelablePromise<StoreHistoryManagementShowOrderResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/store-history/show',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * 注文情報ダウンロードのhtml出力URL作成
     * @param requestBody
     * @returns StoreHistoryManagementExportOrderResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminStoreHistoryExportOrder(
        requestBody: StoreHistoryManagementExportOrderRequest,
    ): CancelablePromise<StoreHistoryManagementExportOrderResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/store-history/export-order',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * show list items
     * @param requestBody
     * @returns StoreHistoryManagementShowItemResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminStoreHistoryItems(
        requestBody: StoreHistoryManagementShowItemRequest,
    ): CancelablePromise<StoreHistoryManagementShowItemResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/store-history/items',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

}
